import { mkTaxForm, type TaxFormRecord, type TaxFormType } from './taxFormsTypes';

export function transformResponseToTaxForms(
  response?: { data?: { resources?: TaxFormType[] } } | null,
): TaxFormRecord[] | null | undefined {
  const resources = response?.data?.resources;
  if (resources == null) {
    return undefined;
  }
  return resources.map((data: TaxFormType) =>
    mkTaxForm({
      id: data.id,
      country: data.country,
      txfId: data.txfId,
      name: data.name,
      description: data.description,
      displayOrder: data.displayOrder,
      primary: data.primary,
    }),
  );
}
